/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExecutionStatus = {
    Pending: 'Pending',
    Running: 'Running',
    Completed: 'Completed',
    Failed: 'Failed',
    Cancelled: 'Cancelled'
} as const;
export type ExecutionStatus = typeof ExecutionStatus[keyof typeof ExecutionStatus];


export function instanceOfExecutionStatus(value: any): boolean {
    for (const key in ExecutionStatus) {
        if (Object.prototype.hasOwnProperty.call(ExecutionStatus, key)) {
            if (ExecutionStatus[key as keyof typeof ExecutionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExecutionStatusFromJSON(json: any): ExecutionStatus {
    return ExecutionStatusFromJSONTyped(json, false);
}

export function ExecutionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionStatus {
    return json as ExecutionStatus;
}

export function ExecutionStatusToJSON(value?: ExecutionStatus | null): any {
    return value as any;
}

export function ExecutionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ExecutionStatus {
    return value as ExecutionStatus;
}

